import classNames from 'classnames';
import Checkmark from 'icons/ok.svg';
import Globe from 'icons/sprogvaelger.svg';
import { ReactElement } from 'react';
import styles from './LanguageSelectorItem.module.scss';

export interface LanguageSelectorItemProps {
	children?: React.ReactNode;
	selected?: boolean;
	globe?: boolean;
}

export const LanguageSelectorItem: React.FC<LanguageSelectorItemProps> = ({ children, selected, globe }): ReactElement => {
	return (
		<li className={classNames('u-languageSelectorItem', styles.LanguageSelectorItem, selected && styles.LanguageSelectorItem___selected, globe && styles.LanguageSelectorItem_globeWrapper)}>
			{globe && <Globe className={styles.LanguageSelectorItem_globe} />}
			{selected && <Checkmark className={classNames('u-languageSelectorItem_checkmark', styles.LanguageSelectorItem_checkmark)} aria-hidden={true} />} {children}
		</li>
	);
};
